import React, { useState } from 'react'
import classNames from "classnames/bind"

import ToolTip from 'components/shared/toolTip/ToolTip'
import styles from './text-area.module.scss';
const cx = classNames.bind(styles)

export const TextArea = ({props}) => {

    const [isFocused, setFocus] = useState()

    const {
        name,
        id,
        value,
        handleOnChange,
        icon,
        hasError,
        isRequired,
        requiredText,
        label,
        placeholder,
        hasTooltip,
        tooltipMessage
    } = props

    const handleFocus = () => {
        setFocus(true)
    }

    const handleBlur = () => {
        setFocus(false)
    }

    return (
        <div className={cx(['outer-textarea-field-wrapper'])}>
            <label htmlFor={name}>
                <span className={cx('label-wrapper')}>
                    {label}
                    {isRequired && <sup>*</sup>}

                    {hasTooltip &&
                    <span className={cx('tooltip-wrapper')}>
                            <ToolTip
                                message={tooltipMessage}
                            />
                        </span>
                    }
                </span>
                <span className={cx(['textarea-wrapper'], {
                    'textarea-wrapper__focused': isFocused === true,
                    'textarea-wrapper__error': hasError === true
                })}>
                    <textarea
                        name={name}
                        id={id}
                        value={value}
                        onChange={(e) => handleOnChange(e)}
                        onFocus={() => handleFocus()}
                        onBlur={() => handleBlur()}
                        placeholder={placeholder}
                    />
                </span>

                {icon &&
                <span className={cx('icon-wrapper')}>

                    </span>
                }
            </label>
            {hasError && requiredText &&
            <p className={cx('required-text')}>{requiredText}</p>
            }
        </div>
    )
}

export default TextArea